import React from 'react';
import { AppBar, Toolbar, IconButton, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDrawerContext } from '../../contexts/DrawerContext';
import ZigyLogo from '../shared/ZigyLogo';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';

/**
 * TopNavigationBar component - Horizontal navigation bar with sidebar toggle and logo
 * 
 * Features:
 * - Toggle button on the left that controls the sidebar (same functionality as existing toggle)
 * - Zigy logo on the right side
 * - Responsive design that works on both mobile and desktop
 * - Integrates with existing useDrawer hook for consistent state management
 * 
 * @returns {JSX.Element} TopNavigationBar component
 */
const TopNavigationBar = () => {
  const theme = useTheme();
  const { handleDrawerToggle, miniDrawer, mobileOpen, isDesktop } = useDrawerContext();

  const handleToggleClick = () => {
    console.log('TopNavigationBar toggle clicked - Before:', { miniDrawer, mobileOpen, isDesktop });
    handleDrawerToggle();
    // Log after a brief delay to see the state change
    setTimeout(() => {
      console.log('TopNavigationBar toggle clicked - After:', { miniDrawer, mobileOpen, isDesktop });
    }, 100);
  };

  return (
    <AppBar
      position="fixed"
      className='top-nav-bar'
      sx={{
        zIndex: theme.zIndex.drawer + 1, // Ensure it appears above the drawer
        bgcolor: 'var(--bg-panel) !important',
        backdropFilter: 'var(--effect-panel-backdrop-filter)',        color: theme.palette.text.primary,
        borderRadius: '0',
        borderWidth: '0 0 var(--border-width) 0',
        borderColor: 'var(--color-border)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: 'var(--topnavbar-height) !important',
          zIndex: 'var(--mui-zIndex-drawer)',
          paddingX: `${theme.spacing(2)} !important`,
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '1rem',
          alignItems: 'center',
        }}
      >
        {/* Toggle button */}
          <IconButton
            onClick={handleToggleClick}
            edge="start"
            sx={{
              color: theme.palette.text.muted,
              bgcolor: 'transparent',
              borderRadius: 'var(--radius-md)',
              marginLeft: '0',
              '&:hover': {
                bgcolor: 'var(--sidebar-item-active-bg)',
                color: theme.palette.primary.main,
              },
            }}
            aria-label="toggle sidebar"
          >
            {miniDrawer ? <UnfoldMoreIcon sx={{rotate: '45deg', width: 20, height: 20}} /> : <UnfoldLessIcon sx={{rotate: '45deg', width: 20, height: 20}} />}
          </IconButton>

        {/* Logo */}
          <ZigyLogo
            width={75}
            height={28}
          />
          <h1 className="sr-only">Zigy</h1>
      </Toolbar>
    </AppBar>
  );
};

export default TopNavigationBar;
